module.exports = __webpack_public_path__ + "static/love-letters-to-the-dead-d2e50a21c31ee71f80cc9b832394cb79.jpg";